import React, { memo, useState } from 'react'
import { useAppSelector } from '../../../../ReduxTool/store/hooks';
import { Accordion } from '../NewSiteAnalyze';
import moment from 'moment';
import { ThickMarkIcon } from '../../../../assests/icons/Icons';
import { getCurrencyLabel, convertRupeeToCurrency, dcPowerBasedOnSanctionload } from '../../../../Utils/commonFunctions';

interface TimelineStepProps {
    id?: number;
    label: string;
    status: 'completed' | 'in-progress' | 'pending' ;
    // status: 'completed' | 'in-progress' | 'pending';
    subtext: string;
  }

function InstallationTracking() {
    const { user: { country_mstr } } = useAppSelector(state => state.auth)
       const { roofAnalysis: { formDetails: { projectSetup: { lat, lng, address }, projectSetup, error, }, selected_project, isWithRoof, useableArea, obsArea,countryName,regionName } } = useAppSelector(state => state.consumerReducers);
       const [openSubAccordian, setOpenSubAccordian] = useState({finalproposal:true,})
       const formateData = (date: string) => `${moment(new Date(date)).format("DD-MM-YYYY")} at ${moment(new Date(date)).format("hh:mm A")}`
      //  console.log("date --->>  " ,moment(new Date(selected_project?.proposal_createdon?? "")).format("DD-MM-YYYY"))

       // --- CHANGES MADE: DYNAMIC TIMELINE DATA ---
  // A function to determine the status and subtext for each timeline step based on the provided userData.
  const getTimelineData = () => {
    const { installer_assignment, installer_project_mapping, rfp_id } = selected_project as any;
    // debugger
     interface TimelineStepProps { id?: number; label: string; status: 'completed' | 'in-progress' | 'pending' ;
    // status: 'completed' | 'in-progress' | 'pending';
    subtext: string;  }
     type TimelineDataProps = TimelineStepProps[]

    const data: TimelineDataProps = [
      { id: 1,    label: 'Proposal Received',    status: 'completed',     subtext: formateData(selected_project?.proposal_createdon ?? "").slice(0, 10)   },
      {
        id: 2,  label: 'Contract Negotiation',    // status: installer_assignment === 2 ? 'completed' : installer_assignment === 1 || rfp_id !== null ? 'in-progress' : 'pending',
        status:  (selected_project as any)?.issubscribed || selected_project?.isepccomplete  ?  "completed"  : 'in-progress',  // subtext: installer_assignment === 2 ? 'Completed' : installer_assignment === 1 || rfp_id !== null ? 'In Progress' : 'Yet to start',
        subtext: (selected_project as any)?.issubscribed || selected_project?.isepccomplete ? moment(new Date(selected_project?.epccompleteon!)).format("DD-MM-YYYY") : selected_project?.iscompleted === true ? 'In Progress' : 'Yet to start',
      },
      {  id: 3,   label: 'Site Inspection', status: installer_project_mapping?.site_inspection_data?.status === 'Completed' ? 'completed' : installer_project_mapping?.site_inspection_data ? 'in-progress' : 'pending',
        subtext: installer_project_mapping?.site_inspection_data?.status === 'Completed' ? 'Completed' : installer_project_mapping?.site_inspection_data ? 'In Progress' : 'Yet to start',
      },
      { id: 4, label: 'Mounting Solar Panels',   status: installer_project_mapping?.mounting_solar_panel_data?.status === 'Completed' ? 'completed' : installer_project_mapping?.mounting_solar_panel_data ? 'in-progress' : 'pending',
        subtext: installer_project_mapping?.mounting_solar_panel_data?.status === 'Completed' ? 'Completed' : installer_project_mapping?.mounting_solar_panel_data ? 'In Progress' : 'Yet to start',
      },
      {  id: 5, label: 'Inverter & Battery Installation', status: installer_project_mapping?.inverter_and_battery_installation?.status === 'Completed' ? 'completed' : installer_project_mapping?.inverter_and_battery_installation ? 'in-progress' : 'pending',
        subtext: installer_project_mapping?.inverter_and_battery_installation?.status === 'Completed' ? 'Completed' : installer_project_mapping?.inverter_and_battery_installation ? 'In Progress' : 'Yet to start',
      },
      { id: 6, label: 'Electrical Wiring & Connections', status: installer_project_mapping?.electrical_wiring_and_connections?.status === 'Completed' ? 'completed' : installer_project_mapping?.electrical_wiring_and_connections ? 'in-progress' : 'pending',
        subtext: installer_project_mapping?.electrical_wiring_and_connections?.status === 'Completed' ? 'Completed' : installer_project_mapping?.electrical_wiring_and_connections ? 'In Progress' : 'Yet to start',
      },
      { id: 7, label: 'QA Checks & System Test',  status: installer_project_mapping?.qa_checks_and_system_test?.status === 'Completed' ? 'completed' : installer_project_mapping?.qa_checks_and_system_test ? 'in-progress' : 'pending',
        subtext: installer_project_mapping?.qa_checks_and_system_test?.status === 'Completed' ? 'Completed' : installer_project_mapping?.qa_checks_and_system_test ? 'In Progress' : 'Yet to start',
      },
      { id: 8, label: 'Handover & Customer Sign-Off', status: installer_project_mapping?.handover_and_customer_sign_off?.status === 'Completed' ? 'completed' : installer_project_mapping?.handover_and_customer_sign_off ? 'in-progress' : 'pending',
        subtext: installer_project_mapping?.handover_and_customer_sign_off?.status === 'Completed' ? 'Completed' : installer_project_mapping?.handover_and_customer_sign_off ? 'In Progress' : 'Yet to start',
      }
    ];

    return data;
  };

   const TimelineStep: React.FC<TimelineStepProps> = ({ label, status, subtext }) => {
      const getStatusIndicator = () => {
        switch (status) {
          case 'completed':
            return (
              <div className="size-5 border-2 border-custom-primary-default flex items-center justify-center rounded-full">
                <ThickMarkIcon className="size-3 fill-custom-primary-default" />
              </div>
            );
          case 'in-progress':
            return (
              <div className="size-5 border-2 border-custom-primary-default flex items-center justify-center rounded-full">
                <span className="size-2 rounded-full bg-custom-primary-default" />
              </div>
            );
          case 'pending':
          default:
            return (
              <div className="size-5 border-2 border-gray-300 flex items-center justify-center rounded-full">
                <span className="size-2 rounded-full bg-gray-300" />
              </div>
            );
        }
      };
  
      return (
        <li className="flex justify-between items-center">
          <div className="flex items-center gap-2 font-semibold">
            {getStatusIndicator()}
            <span className='text-14-inter-medium-info'>{label}</span>
          </div>
          <span className="text-sm">{subtext}</span>
        </li>
      );
    };
       
  return (
      <><Accordion isDisable={false} isOpen={openSubAccordian.finalproposal} title={"Order Status"} onToggle={()=>setOpenSubAccordian(prev=>({...prev,finalproposal:!prev.finalproposal}))} maxh="fit-content" >
        <div className="max-w-md mx-auto bg-white px-1 font-sans text-[#1a1c1e]">
           <div className={"block"}>
        {/* <div className="max-w-xl h-px my-4 flex justify-center self-stretch bg-gradient-to-tr from-transparent via-neutral-600 to-transparent opacity-25 "></div> */}
        {/* <h4 className="mb-2 para-md">
              Order Status
            </h4> */}
            {
            selected_project?.installationmode === "pvNXT Mode" ? <>
             <ul className="para-sm text-slate-600 space-y-3">
               {getTimelineData()?.map((step) => (
                 <TimelineStep key={step.id} label={step.label}  status={step.status} subtext={step.subtext}  />
               ))}
             </ul>
             </> : 
             <>
              <div className={``}>
                  <h4 className="mb-2 para-md">  Project Details  </h4>
                  <ul className="para-sm text-slate-600">
                    <li> {selected_project && (selected_project?.address.length > 44 ? selected_project.address!.substring(0, 44) + "..." : selected_project.address)}</li>
                    <li>Boundary: {selected_project && selected_project.graphicLayer ? "Yes" : "No"}</li>
                    <li>Project Type: {selected_project && ` ${selected_project?.projecttype}` }</li>
                    <li>Project Cost: {selected_project && convertRupeeToCurrency(+selected_project?.projectcost, country_mstr?.currencyrate ?? 1, getCurrencyLabel(country_mstr))}</li>
                    <li>AC/DC: {selected_project && dcPowerBasedOnSanctionload(selected_project.sanctionload)}/{selected_project && (selected_project?.sanctionload)}kW</li>
                  </ul>
                </div>
              </>
            }

      </div>
        </div>
        </Accordion>
        </>
  )
}

export default memo(InstallationTracking)